<script lang="ts" setup>
  import {
    filterEmits,
    filterProps,
    FILTER_EVENT_STATE_CHANGE,
  } from "frontend/uses/filter/use-filter";
  import { PrimaryKey } from "frontend/interfaces/primary-key";
  import { FormSelectOption } from "frontend/uses/use-form-select";

  import FormCheckboxGroup from "frontend/components/form/FormCheckboxGroup.vue";

  interface FilterState {
    selectedIDs: Array<PrimaryKey>;
  }

  interface FilterOptions {
    label: string;
    options: Array<FormSelectOption>;
  }

  defineProps({
    ...filterProps<FilterState, FilterOptions>(),
  });

  const emit = defineEmits([...filterEmits()]);

  const onSelectionChanged = (selectedIDs: Array<PrimaryKey>) => {
    emit(FILTER_EVENT_STATE_CHANGE, {
      selectedIDs,
    });
  };
</script>

<template>
  <div>
    <FormCheckboxGroup
      v-bind:model-value="filterState.selectedIDs"
      v-bind:label="filterOptions.label"
      v-bind:options="filterOptions.options"
      visual-small
      v-on:update:model-value="onSelectionChanged"
    />
  </div>
</template>
